import { render, staticRenderFns } from "./VerOrdenes.vue?vue&type=template&id=342ed472&scoped=true&"
import script from "./VerOrdenes.vue?vue&type=script&lang=js&"
export * from "./VerOrdenes.vue?vue&type=script&lang=js&"
import style0 from "./VerOrdenes.vue?vue&type=style&index=0&id=342ed472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342ed472",
  null
  
)

export default component.exports